import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../api/api";
import { toast } from "react-toastify";
import { Carousel } from "react-bootstrap";
import Slider from "../components/Slider";


export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  const navigate = useNavigate();

  // ==========================
  // SEND / RESEND OTP
  // ==========================
  const sendOtp = async () => {
    if (!email) {
      toast.error("Email is required");
      return;
    }

    if (cooldown > 0) {
      toast.info(`Please wait ${cooldown}s before resending`);
      return;
    }

    try {
      setLoading(true);
      await api.post("/password/send-otp", { email });

      toast.success("OTP sent to your email");
      startCooldown();

      // Navigate only first time
      navigate("/reset-password", { state: { email } });
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  // ==========================
  // COOLDOWN TIMER (30s)
  // ==========================
  const startCooldown = () => {
    let time = 30;
    setCooldown(time);

    const timer = setInterval(() => {
      time--;
      setCooldown(time);

      if (time <= 0) {
        clearInterval(timer);
      }
    }, 1000);
  };

  return (
  <main className="login-screen">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-md-6 left-sec">
          <img src="images/logo.svg" className="logo" />

        <div className="link-sec"><Link to="/login">  <i className="bi bi-chevron-left"></i> Back to Login</Link></div>
        <h1 className="title1">Forgot your password?</h1>
        <div className="subtitle2">Enter your Email and get OTP to verification.</div>
        <div className="mt-4">
          <div className="input-wrapper mb-2">
                  <img src="/icons/email.svg" alt="email" className="input-icon left" />
          <input
            className="form-control mb-3 form_input"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
 </div>
          {/* SEND OTP */}
          <button
            className="btn-style1 mt-4"
            onClick={sendOtp}
            disabled={loading}
          >
            {loading ? "Sending..." : "Get OTP"}
          </button>

          {/* RESEND OTP */}
          {/* <button
            className="btn btn-outline-secondary w-100 mt-2"
            onClick={sendOtp}
            disabled={cooldown > 0 || loading}
          >
            {cooldown > 0
              ? `Resend OTP in ${cooldown}s`
              : "Resend OTP"}
          </button> */}
        <div className="footer-text">  <a
  href="#"
  className={`mt-2 ${
    cooldown > 0 || loading ? "disabled" : ""
  }`}
  onClick={(e) => {
    e.preventDefault();
    if (cooldown > 0 || loading) return;
    sendOtp();
  }}
>
  {cooldown > 0
    ? `Resend OTP in ${cooldown}s`
    : "Resend OTP"}
</a>
</div>

          </div>
        </div>
        <div className="col-md-6">
              <Slider className="login-slider">
            <Carousel.Item>
              <img src="images/slide1.png" className="img-fluid" />
              <Carousel.Caption>
                <h2>Forgot your password?</h2>
                <p>You can get them back easily.</p>
              </Carousel.Caption>
            </Carousel.Item>

            <Carousel.Item>
              <img src="images/slide2.png" className="img-fluid" />
              <Carousel.Caption>
                <h2>Slide 2</h2>
                <p>Slide 2 subtext</p>
              </Carousel.Caption>
            </Carousel.Item>
          </Slider>
        </div>
      </div>
    </div>

    {/* <div className="container mt-5">
      <div className="card col-md-4 mx-auto p-4 shadow-sm">
        <h4 className="text-center mb-3">Forgot Password</h4>

        <input
          className="form-control mb-3"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

       
        <button
          className="btn btn-primary w-100 mb-2"
          onClick={sendOtp}
          disabled={loading}
        >
          {loading ? "Sending..." : "Send OTP"}
        </button>

        <button
          className="btn btn-outline-secondary w-100"
          onClick={sendOtp}
          disabled={cooldown > 0 || loading}
        >
          {cooldown > 0
            ? `Resend OTP in ${cooldown}s`
            : "Resend OTP"}
        </button>
      </div>
    </div> */}
    </main>
  );
}
